export enum ProgressBarEnum {
  Slow = 10000,
  Medium = 5000,
  Fast = 1000,
  VeryFast = 500,
  SuperFast = 100,
  UltraFast = 50,
}
